import { render } from "./FundPanel.vue?vue&type=template&id=613f2090&ts=true"
import script from "./FundPanel.vue?vue&type=script&lang=ts"
export * from "./FundPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__